const walkthroughIds = {
    companies: {
        general: {
            ufAddButton: '/companies/button/add',
            ufEditButton: '/companies/button/edit',
            ufManageButton: '/companies/button/manage',
            ufCreateButton: '/companies/button/create',
            ufDeleteBtn: '/companies/button/delete',
            ufBackBtn: '/companies/button/back',
            ufSaveBtn: '/companies/button/save',
        },
    },
    approval: {
        ufApproveButton: '/companies/approval/button/approve',
        ufApproveAsTrialButton: '/companies/approval/button/approve-trial',
    },
};

export default walkthroughIds;
